import moment from 'moment';

/**
 * @param {moment} timesGridStartDate - current starting date of the times grid
 * @param {int} numDays - size of the range of days we are going to get
 * @param (int) maxDaysToMoveBack - maximum number of days we will shift the range
 *                                  backwards in the direction of today's date if
 *                                  timesGridStartDate is in the future.
 * @returns {Array.<moment>}
 */
export default function getDateRange(startDate, numDays) {
    const dates = [];

    for (let i = 0; i < numDays; i++) {
        dates[i] = moment(startDate).add(i, 'days');
    }

    return dates;
}
